import type L from "leaflet";
import type { RequestedPicturesPlotDataResponse } from "../../types";

/**
 * プロットIDを生成する
 * @param plot プロットデータ
 * @returns プロットID
 */
export const generatePlotId = (
  plot: RequestedPicturesPlotDataResponse
): string => {
  return `${plot.prefectureName}-${plot.location}-${plot.chiban}`;
};

/**
 * 古いマーカーをクリーンアップする
 * @param markersCache マーカーキャッシュ
 * @param currentPlotIds 現在のプロットID
 * @param layer レイヤー
 */
export const cleanupObsoleteMarkers = (
  markersCache: Map<string, L.Layer>,
  currentPlotIds: Set<string>,
  layer: L.LayerGroup | null
): void => {
  const obsoleteIds: string[] = [];

  markersCache.forEach((_, plotId) => {
    if (!currentPlotIds.has(plotId)) {
      obsoleteIds.push(plotId);
    }
  });

  obsoleteIds.forEach((plotId) => {
    const marker = markersCache.get(plotId);
    if (marker && layer) {
      layer.removeLayer(marker);
    }
    markersCache.delete(plotId);
  });
};
